import { render, staticRenderFns } from "./PassengerDialog.vue?vue&type=template&id=dba263e4"
import script from "./PassengerDialog.vue?vue&type=script&lang=ts"
export * from "./PassengerDialog.vue?vue&type=script&lang=ts"
import style0 from "./PassengerDialog.vue?vue&type=style&index=0&id=dba263e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports